<template>
  <section :class="[reviewingOrder ? 'open' : '', 'sidebar-cart']">
    <h4>{{ $t('cart.yourItems') }}</h4>
    <Cart
      v-if="reviewingOrder"
    />
  </section>
</template>

<script>
import Cart from '../cart/cart'

export default {
  components: {
    Cart
  },

  props: ['currentsection', 'number'],

  data() {
    return {
      sectionName: 'cart'
    }
  },

  computed: {
    reviewingOrder() {
      if (this.currentsection == 'review' || this.currentsection == 'payment') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
